// @ts-nocheck
import { Button } from "@mui/material";
import { getCssVariableHandler } from "../../../../utils/styles/getCssVariables";
import { DeleteOutline } from "@mui/icons-material";
import PropTypes from "prop-types";
import { Feedback } from "@mui/icons-material";

export function CustomDeleteIcon({ onClick }) {
  return (
    <Button
      sx={{
        marginLeft: "10px",
        borderRadius: "10px",
        // border: "1px solid #FFF",
        background: getCssVariableHandler({
          variableName: "--primary-pink-rgb",
        }),
        boxShadow: "0px 0px 20px 0px rgba(209, 117, 182, 0.40)",
        minWidth: "auto",
        padding: "5px !important",
      }}
      onClick={onClick}
    >
      <DeleteOutline />
    </Button>
  );
}

CustomDeleteIcon.propTypes = {
  onClick: PropTypes.func,
};

export function CustomFeedbackIcon({ onClick }) {
  return (
    <Button
      sx={{
        marginLeft: "10px",
        borderRadius: "10px",
        background: getCssVariableHandler({
          variableName: "--primary-pink-rgb",
        }),
        boxShadow: "0px 0px 20px 0px rgba(209, 117, 182, 0.40)",
        minWidth: "auto",
        padding: "5px !important",
      }}
      onClick={onClick}
    >
      <Feedback />
    </Button>
  );
}

CustomFeedbackIcon.propTypes = {
  onClick: PropTypes.func,
};